/**
 * Generated runtime TestId mirror for frontend/src/components/ui/combobox.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ComboboxTestIds = {
  btnClearSelection: "btn-clear-selection",
  btnSelectOption: (option_value: string) => `btn-select-option-${option_value}`,
  btnSelectOptionPrefix: () => "btn-select-option-" as TestIdPrefix
} as const;
